export default __webpack_public_path__ + "theme-noreact/assets/no-image-3041b99b.svg";